RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TextDiffAlert = views.Alert.extend({
        template: '#alertsTextDiffAlertTemplate',
        getDiffPrevious: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;

            return eventDisplay.getTextDiff(data.event_type_id, data, $.noop);
        },
        getDiffCurrent: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;

            return eventDisplay.getTextDiff(data.event_type_id, data, null, $.noop);
        },
        getDiffSubject: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;

            const subject = eventDisplay.getTextDiffSubject(data.event_type_id);
            return subject;
        },
        getAlertIconClassName: function () {
            const me = this;
            const eventTypeId = me.model.get('event_type_id');
            const eventDisplay = RivalIQ.utils.eventDisplay;

            const sourceDetails = eventDisplay.getSourceDetails(eventTypeId);
            return sourceDetails.fontIcon;
        },
        augmentTemplateData: function (data) {
            const me = this;

            views.Alert.prototype.augmentTemplateData.apply(me, arguments);

            data.diffCurrent = me.getDiffCurrent(data);
            data.diffPrevious = me.getDiffPrevious(data);
            data.diffSubject = me.getDiffSubject(data);
        }
    });

});
